import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchData, joinDataArrays } from '../functions';
import SearchBar from './SearchBar';
import TagList from './TagList';

export default function ItemSearch() {
  const location = useLocation();
  const navigate = useNavigate();
  const tagTagTypeQuery = useQuery('tagTagTypeData', () => fetchData('tag-tag-type'));
  const tagTypeQuery = useQuery('tagTypeData', () => fetchData('tag-type'));
  const tagQuery = useQuery('tagData', () => fetchData('tag'));
  const [completeTagData, setCompleteTagData] = useState([]);
  const [searchByKeyWord, setSearchByKeyWord] = useState(true);
  const [inclusiveSearch, setInclusiveSearch] = useState(true);
  const [selectedTags, setSelectedTags] = useState({ tags: [] });
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (!searchByKeyWord) {
      setSearchValue('')
    } else {
      setSelectedTags((prevData) => ({
        ...prevData,
        tags: []
      }));
    }
  }, [setSelectedTags, searchByKeyWord]);

  const handleTagClick = (clickedTag) => {
    const isTagSelected = selectedTags.tags.some(tag => tag.id === clickedTag.id);
    const updatedTags = isTagSelected
      ? selectedTags.tags.filter(tag => tag.name !== clickedTag.name)
      : [...selectedTags.tags, clickedTag];
    setSelectedTags((prevData) => ({
      ...prevData,
      tags: updatedTags,
    }));
    if (searchValue) {
      setSearchValue('')
    }
  };

  const toggleSearchType = (event) => {
    event.preventDefault();
    setInclusiveSearch(!inclusiveSearch)
  };

  const handleSearch = (event) => {
    event.preventDefault();
    if (searchValue) {
      const encodedSearchValue = encodeURIComponent(searchValue.trim());
      navigate(`/cats/search/des=${encodedSearchValue}`);
    } else if (selectedTags.tags.length === 1) {
      navigate(`/cats/search/tag=${selectedTags.tags[0].id}`)
    } else if (selectedTags.tags.length > 1) {
      navigate(`/cats/search/${inclusiveSearch ? 'inclusive' : 'exclusive'}-tags=${selectedTags.tags.map(tag => tag.id)}`)
    }
  };

  useEffect(() => {
    if (tagTagTypeQuery.data && tagTypeQuery.data && tagQuery.data) {
      const tagTagTypesWithTagTypeNames = joinDataArrays(tagTagTypeQuery.data, 'tag_type_id', tagTypeQuery.data, 'id', { type: 'type' });
      const tagsWithTagTypes = joinDataArrays(tagQuery.data, 'id', tagTagTypesWithTagTypeNames, 'tag_id', { id: 'tag_type_id', type: 'type' }, 'tagTypes');
      setCompleteTagData(tagsWithTagTypes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagTagTypeQuery.data, tagTypeQuery.data, tagQuery.data]);

  if (tagTagTypeQuery.isLoading || tagTypeQuery.isLoading || tagQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (tagTagTypeQuery.isError || tagTypeQuery.isError || tagQuery.isError) {
    return <div>Error loading data</div>;
  }

  return (
    <div>
      <div>
        <div>
          <div>
            <button 
              onClick={() => setSearchByKeyWord(!searchByKeyWord)} 
              style={{ backgroundColor: searchByKeyWord ? '#4ca7af' : '#f0f0f0', color: searchByKeyWord ? 'white' : 'black' }}
            >
              Search by Key Word
            </button>
            <button 
              onClick={() => setSearchByKeyWord(!searchByKeyWord)} 
              style={{ backgroundColor: !searchByKeyWord ? '#4ca7af' : '#f0f0f0', color: !searchByKeyWord ? 'white' : 'black' }}
            >
              Search by Tags
            </button>
          </div>
          {searchByKeyWord && (
            <SearchBar searchValue={searchValue} setSearchValue={setSearchValue} placeHolder={'Search by Key Word'} onSearch={handleSearch}/>
          )}
        </div>
        {!searchByKeyWord && (
          <div>
            <div>
              <TagList
                itemFormData={selectedTags}
                completeTagData={completeTagData}
                tagTypeData={tagTypeQuery.data}
                onTagClick={handleTagClick}
              />
            </div>
          </div>
        )}
        <div>
        {!searchByKeyWord
          && (location.pathname === '/cats/merchant/assets'
            || location.pathname.startsWith('/cats/browse')
            || location.pathname.startsWith('/cats/search')
          ) && selectedTags.tags.length > 1 && (
          <button onClick={toggleSearchType}>Toggle Filter Type</button>
        )}
        </div>
        <button type="submit" onClick={handleSearch} disabled={!searchValue && selectedTags.tags.length === 0}>{
          !searchByKeyWord
            ? selectedTags.tags.length > 1
              ? inclusiveSearch
                ? 'Search Inclusively'
                : 'Search Exclusively'
              : 'Search'
            : 'Search'
        }
        </button>
      </div>
    </div>
  );
}
